import { Component } from '@angular/core';

@Component({
  selector: 'app-dots-spinner',
  templateUrl: './dots-spinner.component.html',
  styleUrls: ['./dots-spinner.component.scss'],
  host: {
    'class': 'dots-spinner'
  }
})
export class DotsSpinnerComponent {}
